(function Module() {
	'use strict';
	mySynch.controller('ResultWriteReportV1_3Controller', [
		'$scope',
		'$rootScope',
		'$interval',
		'$q',
		'ApiFactory',
		'F360Service',
		'AuditService',
		'F360Constant',
		'F360ChartService',
		'CookieFactory',
		'$location',
		'$filter',
		'$window',
		'$anchorScroll',
		'MySynchFactory',
		'clientLoggerService',
		function ResultWriteReportV1_3Controller($s,$rootScope,$interval,$q,api, f360Service, auditService, constant,ChartService,cookies, $location,$filter,$window,$anchorScroll,MSF, log) {
			console.log("@@@@@@@@@ V1.3 Write Results @@@@@@@@");
			window.scrollTo(0, 0);
			self.auditId = auditService.getAuditId($location.url());
			$s.breadcrumbs = f360Service.getReport360Breadcrumbs();
			$s.lastBreadcrumbs = $s.breadcrumbs.pop();

			$s.isOnline = $rootScope.onLine;

			self.managementPlan = '';
			self.farmWalkThroughCmt = '';
			self.interviewCmt = '';
			self.dataQualityCmt = '';
			self.reproductivePerformanceCmt = '';
			self.freshCowDiseasesCmt = '';
            $s.overViewList = [];
			$s.auditAnswers = [];
			$s.auditQuestions = [];

            // question table , followup item and chart data source variables 
			$s.sectionsQuestionsAndAnswers = [];
			$s.orderedQuestionsAndAnswers = [];
			$s.allMetGuidelineQuestions = [];
			$s.allOutsideGuidelineQuestions = [];
			$s.allMetGuidelineQuestionsWithGuidelines = [];
			$s.allOutsideGuidelineQuestionsWithGuidelines = [];
		   
			
			$s.followupItems = [];
		  
			
			$s.minNextEvaluationDate = moment().toDate();//formatDate(moment().toDate());
			$s.maxNextEvaluationDate = moment().add('days', 180).toDate();//getMaxNextEvaluationDate(new Date(),6);

			//validation anchore ids and tab indexs used for scrolling to the top validation error
			$s.managementPlanAnchor = "managementPlan-textarea";
			$s.managementPlanTabIndex = 0;
			$s.followupItemsAnchor = "followupItems";
			$s.followupItemsTabIndex = 1;
			$s.nextEvaluationDateAnchor = "nextEvaluationDate";
			$s.nextEvaluationDateTabIndex = 2;

			$s.currentTopAnchor = "";
			$s.currentTopTabIndex = ""; 


			$s.mySynchState = {};
			$s.activeFarm = {};
			$s.currentHerd = {};


			$s.auditApiVersion;

			// watcher degresigration variables
			var deregOnFarmChange = undefined;
			var deregOnlineCheckWatch = undefined;

			// flag for that is set true when and update answers or update reviewdraft call occurs successfuly without updating the server
			$s.syncInProgress = false;
			$s.initCheckSyncInProgress = false;
			$s.isDirty = false;
			$s.updateInProgress = false;

			$s.checkSyncStatusTimer = undefined;


		
			$s.defaultReportData = {"resultsWriteRptJson":{"formattedHighlights":"","nextEvaluationDate":"","comments":[{"section": "FARMWALKTHRU","formattedComments":""},{"section": "INTERVIEW","formattedComments":""},{"section": "DATAQUALITY","formattedComments":""},{"section": "REPRODUCTIVITY","formattedComments":""},{"section": "FRESHCOWDISEASE","formattedComments":""}]},"reviewDraftRptJson":{"reportDate":"","milkingCnt": null,"pregRate":null,"concRate":null,"reviewedReport":false,"actionItemGroups":[]}};
			$s.report = angular.copy($s.defaultReportData);


			$s.codeFile = [];
	
			//------- chart variables
			$s.overallSummaryPieChart = {
				chart: {},
				title: "",
				seriesData: [] 
			};
			$s.sectionPieCharts = [];
            $s.sectionBarChart = {
				chart: {},
				title: "",
				seriesData: []
			};
			$s.categoryBarChart = {
				chart: {},
				title: "",
				seriesData: []
			};
              
			$s.questionSectionsPieChartData = [];
		 
			$s.codeFileQuestionCategories = [];
			
			
		

			//-------------------


			document.getElementById("nextEvaluationDate").valueAsDate = new Date();
			$(document).ready(function () {
				window.scrollTo(0,0);
			});
			var titleBar = 'Questions that Met Industry Guideline by Category';
			var dataOfBarChart = [
				{'name':'Enviroment', 'metindustry':12, 'notmetindustry':5},
				{'name':'Nutrition',  'metindustry':19, 'notmetindustry':8},
				{'name':'Personnel',  'metindustry':3,  'notmetindustry':7},
				{'name':'Product', 	  'metindustry':5,  'notmetindustry':9},
				{'name':'Protocol',   'metindustry':2,  'notmetindustry':4},
				{'name':'Other',      'metindustry':3,  'notmetindustry':6},
			];
			var barChart = document.getElementById("barChart");
		//	ChartService.getBarChart(barChart, dataOfBarChart, titleBar);
			var titleSectionBar = 'Questions that Met Industry Guideline by Evaluation Section';
			var dataOfSectionChart = [
				{'name':'Data Quality', 				 'metindustry':20,  'notmetindustry':32},
				{'name':'Fresh Cows',  					 'metindustry':21,  'notmetindustry':30},
				{'name':['Reproductive', 'Performance'], 'metindustry':19,  'notmetindustry':31},
				{'name':'Inverview', 	  				 'metindustry':16,  'notmetindustry':25},
				{'name':['Farm', 'Walk-through'],   	 'metindustry':20,  'notmetindustry':32}
			];
			var sectionChart = document.getElementById("sectionChart");
		//	ChartService.getBarChart(sectionChart, dataOfSectionChart, titleSectionBar, 20);
		//	var titlePie = 'Questions that Met Industry Guideline';
			
		//	var dataOfCircleChart = [
		//		{'name':'Met Industry Guideline', 		   'data':60},
		//		{'name':'Did Not Meet Industry Guideline', 'data':40}
		//	];
		//	var canvas = document.getElementById("circleChart");

		///	var circleChart = canvas.getContext('2d');
		//	ChartService.getCircleChart(circleChart, dataOfCircleChart, titlePie);

			var dataOfFreshCowDiseasesChart = [
				{'name':'Met Industry Guideline', 		   'data':80},
				{'name':'Did Not Meet Industry Guideline', 'data':20}
			];
			var canvasFreshCow = document.getElementById("circleFreshCowChart");
			var canvascircleReproductivePerformance = document.getElementById("circleReproductivePerformance");
			var canvascircleDataQuality = document.getElementById("circleDataQuality");
			var canvascircleFarmWalk = document.getElementById("circleFarmWalk");
			var canvascircleInterview = document.getElementById("circleInterview");

			/*var circleFreshCowChart = canvasFreshCow.getContext('2d');
			var circleReproductivePerformanceChart = canvascircleReproductivePerformance.getContext('2d');
			var circleDataQualityChart = canvascircleDataQuality.getContext('2d');
			var circleFarmWalkChart = canvascircleFarmWalk.getContext('2d');
			var circleInterviewChart = canvascircleInterview.getContext('2d');
*/
			var titleFreshCow = 'Fresh Cow Diseases Questions that Met Industry Guideline';
			var titlecircleReproductivePerformance = 'Reproductive Performance Questions that Met Industry Guideline';
			var titlecircleDataQuality = 'Data Quality Questions that Met Industry Guideline';
			var titlecircleFarmWalk = 'Farm Walk-through Questions that Met Industry Guideline';
			var titlecircleInterview = 'Interview Questions that Met Industry Guideline';
/*
			ChartService.getCircleChart(circleFreshCowChart, dataOfFreshCowDiseasesChart, titleFreshCow);
			ChartService.getCircleChart(circleReproductivePerformanceChart, dataOfFreshCowDiseasesChart, titlecircleReproductivePerformance);
			ChartService.getCircleChart(circleDataQualityChart, dataOfFreshCowDiseasesChart, titlecircleDataQuality);
			ChartService.getCircleChart(circleFarmWalkChart, dataOfFreshCowDiseasesChart, titlecircleFarmWalk);
			ChartService.getCircleChart(circleInterviewChart, dataOfFreshCowDiseasesChart, titlecircleInterview);
*/     
	
				function loadPieCharts(){
                    //all data for pie charts are for questions that have an industry guideline
					
					// overall summary pie chart 
					_.set($s.overallSummaryPieChart,'title',"Questions that Met Industry Guideline");
					
				//	 $s.allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
				//	 $s.allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
					
					 // these two lines are being left in to check on the accuracy of the chart data values based on the question property used here to filter.
					// $s.metGuidlineQuestionsNoIndustry = _.filter($s.allMetGuidelineQuestions,function(question){ return _.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) || _.isNull(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
					// $s.outsideGuidelineQuestionsNoIndustry = _.filter($s.allOutsideGuidelineQuestions,function(question){ return _.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) || _.isNull(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});

					var overallSummaryQuestionData = [
						{name: "Met Guideline", data: $s.allMetGuidelineQuestionsWithGuidelines.length},
						{name: "Did Not Meet Guideline", data: $s.allOutsideGuidelineQuestionsWithGuidelines.length}
					];
					_.set($s.overallSummaryPieChart,'seriesData',overallSummaryQuestionData);

					var overallPieChartCanvasElement = document.getElementById("overallSummaryPieChart");// $('#overallSummaryPieChart')[0];
					var overallPieChartElement = overallPieChartCanvasElement.getContext('2d');
					
					var overallPieChartOptions = {
						title:{
							fontSize: 14
						},
						legend:{
							labels:{
								boxWidth: 15
							},
							position: "bottom"
						},
						tooltips:{
							enabled: false
						}
					};
					
				
				$s.overallSummaryPieChart.chart = ChartService.getCircleChart(overallPieChartElement, overallPieChartOptions,$s.overallSummaryPieChart.seriesData, $s.overallSummaryPieChart.title);

				_.forEach($s.sectionsQuestionsAndAnswers,function(section){
					 					
					var sectionChart = {
						chart: {},
						title: "",
						seriesData: [] 
					};
					_.set(sectionChart,'title',section.sectionName+" Questions that Met Industry Guideline");

					var allMetGuidelineQuestionsWithGuidelines = _.filter(section.metGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
					var allOutsideGuidelineQuestionsWithGuidelines = _.filter(section.outsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});         

					var seriesData = [
						{name: "Met Guideline", data: allMetGuidelineQuestionsWithGuidelines.length},
						{name: "Did Not Meet Guideline", data: allOutsideGuidelineQuestionsWithGuidelines.length}
					];
					_.set(sectionChart,'seriesData',seriesData);
					
					var sectionPieChartCanvasElement = document.getElementById("circle-chart-"+section.sectionName);
					var sectionPieChartElement = sectionPieChartCanvasElement.getContext('2d');
					
					var sectionPieChartOptions = {
						legend:{
							labels:{
								boxWidth: 15
							},
							position: "bottom"
						},
						tooltips:{
							enabled: false
						}
					};
					
					
					var chart = ChartService.getCircleChart(sectionPieChartElement, sectionPieChartOptions,sectionChart.seriesData, sectionChart.title);
					_.set(sectionChart,'chart',chart);
					$s.sectionPieCharts.push(sectionChart);
					

				});
							
				}
                
				function loadBarCharts(){
                    
					// section bar chart 
					_.set($s.sectionBarChart,'title',["Questions that Met Industry Guideline by Evaluation Section"]);

					
				 
					
				var sectionBarChartData = {
						categoryLabels: [],
						seriesData : []

				};
				    
					 var metGuidelineQuestionsDataBySection = [];
					 var outsideGuidelineQuestionsDataBySection = [];
					_.forEach($s.sectionsQuestionsAndAnswers,function(section){
						sectionBarChartData.categoryLabels.push(_.get(section,'sectionName',""));			         
                      
						var allMetGuidelineQuestionsWithGuidelines = _.filter(section.metGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
						var allOutsideGuidelineQuestionsWithGuidelines = _.filter(section.outsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});         
	
						metGuidelineQuestionsDataBySection.push(allMetGuidelineQuestionsWithGuidelines.length);
						outsideGuidelineQuestionsDataBySection.push(allOutsideGuidelineQuestionsWithGuidelines.length);
					});

						   
						
					sectionBarChartData.seriesData.push({
						 label: "Met Guideline",
						 data: metGuidelineQuestionsDataBySection,
						 backgroundColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#5C93B4")),
						 borderColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#5C93B4")),
						 borderWidth: _.times(metGuidelineQuestionsDataBySection.length,_.constant(1)),
						 hoverBackgroundColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#3478A2")),
						 hoverBorderColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#3478A2")),
					},{
						label: "Did Not Meet Guideline",
						data: outsideGuidelineQuestionsDataBySection,
						backgroundColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EF8666")),
						borderColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EF8666")),
						borderWidth: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant(1)),
						hoverBackgroundColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EB6841")),
						hoverBorderColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EB6841")),
					});

				

					_.set($s.sectionBarChart,'seriesData',sectionBarChartData);

					var sectionStepSize = 5;

					var sectionBarChartOptions = {
						title: {
							display: true,
							fontSize: 14
						},
						legend:{
							labels:{
								boxWidth: 15
							},
							position: "bottom"
							
						},
						scales: {
							xAxes: [{
							   stacked: false,
							   categoryPercentage: 1.0,
							   barPercentage: 0.75,
							   ticks: {
								   autoSkip: false,
								   //max: _.max(_.map(_.map($s.sectionBarChart.seriesData.seriesData,"data"), function(dataArray){ return _.max(dataArray) })) + sectionStepSize,
							   },
							   afterSetDimensions: function(axes) {
								  // console.log("Inside afterSetDimensions");
									//console.log(axes);
								//    axes.maxWidth = 165;
								   // console.log(axes.width);
								}
								}]
						  },
						tooltips:{
							enabled: false
						}
					}

				   var sectionBarChartCanvasElement = document.getElementById("sectionBarChart");
				   var sectionBarChartElement = sectionBarChartCanvasElement.getContext('2d');
				   $s.sectionBarChart.chart  =  ChartService.getBarChart(sectionBarChartElement,sectionBarChartOptions, $s.sectionBarChart.seriesData, $s.sectionBarChart.title,sectionStepSize);
				  
				   // Question Category Chart

				   _.set($s.categoryBarChart,'title',["Questions that Met Industry Guideline by Category"]);
                 


				   var metGuidelineQuestionsSeriesDataByCategory = [];
				   var outsideGuidelineQuestionsSeriesDataByCategory = [];

				   var allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
				   var allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});         
			 
				 
				   _.forEach($s.codeFileQuestionCategories,function(codeFileCategory){
					 
					  var metGuidelineQuestionsByCategory = _.filter(allMetGuidelineQuestionsWithGuidelines,{F360Category: _.get(codeFileCategory,'code')});
					  metGuidelineQuestionsSeriesDataByCategory.push(metGuidelineQuestionsByCategory.length);

					  var outsideGuidelineQuestionsByCategory = _.filter(allOutsideGuidelineQuestionsWithGuidelines,{F360Category: _.get(codeFileCategory,'code')});
					  outsideGuidelineQuestionsSeriesDataByCategory.push(outsideGuidelineQuestionsByCategory.length);
                           
				   });

				   var categoryBarChartData = {
					categoryLabels: _.map($s.codeFileQuestionCategories,function(codeFileCategory){ return _.get(codeFileCategory,'codeValue');}),
					seriesData : []

				   };
				   
				  


				   categoryBarChartData.seriesData.push( {
					label: "Met Guideline",
					data: metGuidelineQuestionsSeriesDataByCategory,
					backgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
					borderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
					borderWidth: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
					hoverBackgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
					hoverBorderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
			   },{
				   label: "Did Not Meet Guideline",
				   data: outsideGuidelineQuestionsSeriesDataByCategory,
				   backgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
				   borderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
				   borderWidth: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
				   hoverBackgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
				   hoverBorderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
			   });

			   _.set($s.categoryBarChart,'seriesData',categoryBarChartData);

              var categoryStepSize = 5;

			   var categoryBarChartOptions = {
				   title: {
					   display: true,
					   fontSize: 14
				   },
				   legend:{
					   labels:{
						   boxWidth: 15
					   },
					   position: "bottom"
					   
				   },
				   scales: {
					xAxes: [{
					   stacked: false,
					   categoryPercentage: 1.0,
					   barPercentage: 0.75,
					   ticks: {
						   autoSkip: false,
						   suggestedMax: 40
						   //max: _.ceil(_.max(_.map(_.map($s.categoryBarChart.seriesData.seriesData,"data"), function(dataArray){ return _.max(dataArray) }))/5)*5 + categoryStepSize,
					   }
						}]
				  },
				   tooltips:{
					   enabled: false
				   }
			   };

			  var categoryBarChartCanvasElement = document.getElementById("categoryBarChart");
			  var categoryBarChartElement = categoryBarChartCanvasElement.getContext('2d');
			  $s.categoryBarChart.chart  =  ChartService.getBarChart(categoryBarChartElement,categoryBarChartOptions, $s.categoryBarChart.seriesData, $s.categoryBarChart.title, categoryStepSize);
			
			  


				}

		
				function loadReportCharts(){
					var sectionChartCanvasJQOs = $('[id^="circle-chart-"]');

					if(sectionChartCanvasJQOs.length > 0){
						loadPieCharts();
						loadBarCharts();
						if(!$s.isOnline){
							$s.$apply();
						}
					}else{
						var deregSectionChartCanvasInterval = $interval(function()
						{
							sectionChartCanvasJQOs = $('[id^="circle-chart-"]');
							var sectionChartCanvasExists = sectionChartCanvasJQOs.length > 0;
							
							if(sectionChartCanvasExists){
								loadPieCharts();
								loadBarCharts();
								$interval.cancel(deregSectionChartCanvasInterval);
								
								if(!$s.isOnline){
									$s.$apply();
								}
							}
							
						},100);
					}
				}


				function loadCurrentHerd(callback){
								
					auditService.getHerdsByFarmId(_.get($s.activeFarm,'farmId'), function getF360HerdsByFarmId(err, herd){
						if (err) {
							console.log('err', err);
						}
							$s.currentHerd =  herd[0];
						    var currentHMS = _.get($s.currentHerd,'herdMgmtSoftware');
								   //if the farm doesn't currently have the F360  module on we will want to redirect the user that got here
					
						  if(_.isNull(currentHMS) || _.isUndefined(currentHMS)){
							 MSF.loadPage('Login');
						  }
				
						 callback();
					});

				
				}
				$s.checkPermissions = function checkPermissions(callback){
							
				// we need to check to see if the user who is viewing this screen is the person who create the audit
				// otherwise we need to redirect them to the top level f360 report
					auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
						var auditHerd = _.find(data,{AuditId: self.auditId},'Name');
							
						if(!_.isEqual(_.get(auditHerd,'PersonId'),_.get(cookies.user,'PersonId'))){
							MSF.loadPage('Fertility360report');
						}

						callback();

					});
				};

        function formatDate(date){
	

			return moment(date).format("MM/dd/yyyy");
		}
		function formatDateStringForServer(date){
			
			var formattedDate = date;
			
         		   formattedDate = moment(formattedDate).subtract(moment(formattedDate).utcOffset(), 'minutes').utc().format();
		
		    return formattedDate;
		}
		function formatNextEvaluationDateForServer(date){
			
			var formattedDate = date;
			   
			
			formattedDate = moment(date).format('M/D/YYYY');
		
		    return formattedDate;
		}
        function getDaysInMonth(year, month) {
		   return new Date(year, month, 0).getDate();	
		}
        function getMaxNextEvaluationDate(input,months){
			const date = new Date(input);
            date.setDate(1);
            date.setMonth(date.getMonth() + months);
			date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth()+1)));
            return formatDate(date);
		}
		function removeExcludedQuestions(){
			var notApplicableQuestion = _.find($s.auditQuestions, function(question) {
				return _.isEqual(question.SubHeading,"Dry Cows Far-Off") && _.isEqual(question.QuestionTemplate,"TF");
			  
			  });
		 if(!_.isUndefined(notApplicableQuestion)){
			  var notApplicableQuestionAnswer = _.find($s.auditAnswers,"QuestionId",notApplicableQuestion.QuestionId);	
			  if(_.isEqual(_.get(notApplicableQuestionAnswer,'AnswerDetailsJson.Value',constant.answerFalse),constant.answerTrue)){
				  //if the not applicable TF question is true (checked), we first want to exclude any calculated question that is dependent on the questions in the not applicable TF question's subheading
				   var excludedQuestionIds = [];
				   var subHeadingQuestions = _.filter($s.auditQuestions,{SubHeading: notApplicableQuestion.SubHeading});
				   _.forEach(subHeadingQuestions,function(subHeadingQuestion){
					  var calcTags = _.get(subHeadingQuestion,'QuestionDetailsJson.calcTag',null);
					  
					  if(!_.isNull(calcTags)){
						  _.forEach(calcTags,function(calcTag){
							 
							  var calcQuestion = _.find($s.auditQuestions,function(question){ 
												  
													  var calcVarArray = _.get(question,'QuestionDetailsJson.calculations.calculationVars');
													  if(!_.isUndefined(calcVarArray) && !_.isEmpty(calcVarArray)){
															  var valueTagObjects = [];

															  _.forEach(calcVarArray,function(calcVarObject){
																  var calcVarObjectKey = _.keys(calcVarObject)[0];
																  valueTagObjects.push(calcVarObject[calcVarObjectKey]);
															
																  
															  });
															  var calcQuestionMatch = false;
															  _.forEach(valueTagObjects,function(valueTagObject){
																  if(_.isEqual(subHeadingQuestion.SubHeading,valueTagObject.subHeading) && _.includes(valueTagObject.valueTag,calcTag)){
																	  calcQuestionMatch = true;
																	  return false;		
																  }

															  });


															  return calcQuestionMatch;
													  }
												   
													  
												  });
								 if(!_.isUndefined(calcQuestion) && !_.includes(excludedQuestionIds,calcQuestion.QuestionId)){
									 excludedQuestionIds.push(calcQuestion.QuestionId);
								 }	
						  });
					  }
					  
				   });

				  
				  // then  we want to exclude the questions in that subheading for the counts on the overview screen
				  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.SubHeading,notApplicableQuestion.SubHeading) || _.includes(excludedQuestionIds,question.QuestionId);});

				 
				 
			  }else{
				  //even if the not applicable question is false, we still don't want to include it in the answer count
				  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.QuestionId,notApplicableQuestion.QuestionId);});
			  }	   
		 }
		}
	
		function buildDefaultData(){
			// Next Evaluation Date
			var nextEvalDate = _.get($s.report,'resultsWriteRptJson.nextEvaluationDate');
				if(_.isUndefined(nextEvalDate) || _.isEqual(nextEvalDate,"")){
					nextEvalDate = moment().add('days', 180).toDate();
				}else{
					nextEvalDate = moment(nextEvalDate).toDate();
				}
				
				// in the database next evaluation date is stored as a string, the date input control requires a date
			
				_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',nextEvalDate);

			// other default values will be added here as needed	
		}
		
		function buildReportData(reportData){
			var resultsWriteRptData = _.get(reportData,'resultsWriteRptJson');
			if(!_.isUndefined(resultsWriteRptData)){
				_.set($s.report,'resultsWriteRptJson.formattedHighlights',_.get(resultsWriteRptData,'formattedHighlights',""));
				_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',_.get(resultsWriteRptData,'nextEvaluationDate',""));

			    _.forEach($s.report.resultsWriteRptJson.comments,function(comment,index){
					_.set(comment,'formattedComments',_.get(resultsWriteRptData,'comments['+index+'].formattedComments',""));
				});
			}

			var reviewDraftRptData = _.get(reportData,'reviewDraftRptJson');
			if(!_.isUndefined(reviewDraftRptData)){
				_.set($s.report,'reviewDraftRptJson.reportDate',_.get(reviewDraftRptData,'reportDate',""));
				_.set($s.report,'reviewDraftRptJson.milkingCnt',_.get(reviewDraftRptData,'milkingCnt',null));
				_.set($s.report,'reviewDraftRptJson.pregRate',_.get(reviewDraftRptData,'pregRate',null));
				_.set($s.report,'reviewDraftRptJson.concRate',_.get(reviewDraftRptData,'concRate',null));
				_.set($s.report,'reviewDraftRptJson.actionItemGroups',_.get(reviewDraftRptData,'actionItemGroups',[]));
			}
		} 

        function buildSectionsQuestionsAndAnswers(){
			
		
			
		    _.forEach($s.overViewList,function(section){
				var sectionQuestionAnswerObj = {}; 
				var sectionName = $filter("SectionName")(section.Section);
				_.set(sectionQuestionAnswerObj,'sectionName',sectionName);
				var sectionQuestions = _.filter($s.auditQuestions,function(question){return question.Section === section.Section && question.QuestionId != 1;});
				var metGuidelineQuestions = [];
                var outsideGuidelineQuestions = [];

				_.forEach(sectionQuestions,function(question){
					var answer = _.get(_.find($s.auditAnswers,{QuestionId: question.QuestionId}),'AnswerDetailsJson');
					
					if(!_.isUndefined(answer) && _.has(answer,'MetGuideline')){
						_.set(question,'Answer',angular.copy(answer));

					
				
						if(_.isEqual(_.get(question,"Answer.MetGuideline"),false)){
							outsideGuidelineQuestions.push(question);
						}else{
							metGuidelineQuestions.push(question);
						}
					}else{
						console.error("one or more questions were missing an answer in buildSectionsQuestionsAndAnswers");
					}
						
				});

				

				_.set(sectionQuestionAnswerObj,'metGuidelineQuestions',metGuidelineQuestions);
				_.set(sectionQuestionAnswerObj,'outsideGuidelineQuestions',outsideGuidelineQuestions);
				
				$s.sectionsQuestionsAndAnswers.push(sectionQuestionAnswerObj);
				$s.allOutsideGuidelineQuestions = $s.allOutsideGuidelineQuestions.concat(outsideGuidelineQuestions);
				$s.allMetGuidelineQuestions = $s.allMetGuidelineQuestions.concat(metGuidelineQuestions);
			  
			
				

			}); 

			$s.allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
			$s.allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
		   

			$s.orderedQuestionsAndAnswers = $s.allOutsideGuidelineQuestions.concat($s.allMetGuidelineQuestions);
	
		}

		// function that loads the followup items on load of the results and write report screen
	
		function loadFollowupItems(){
			
			_.forEach($s.sectionsQuestionsAndAnswers,function(section){
				 
				 _.forEach(section.outsideGuidelineQuestions,function(question){
                     if(_.get(question,'Answer.FollowUp')){
						 $s.followupItems.push(question);
					 }
				 });


				 _.forEach(section.metGuidelineQuestions,function(question){
					if(_.get(question,'Answer.FollowUp')){
						$s.followupItems.push(question);
					}
				});


			});
			
		}
		//function that constructs the display value of a given text value  
		$s.getTextDisplayValue  = function getTextDisplayValue(text){

			// replace any measurement standard text 
			var activeFarmMeasurementStandard = _.get($s.activeFarm,'measurementStandard',"");

			text = MSF.getMeasurementStandardReplacementText(activeFarmMeasurementStandard,text);

			return text;

		};

		// function that formats a questions answer value and returns the formatted value
        $s.formatAnswer = function(question){
			
            var formattedAnswerValue = "";

			var questionTemplate = _.get(question,'QuestionTemplate',"");
			var answerValue = _.get(question,'Answer.Value',"");
			var codeType = _.get(question,'CodeType',"");

			switch(questionTemplate){
				case "%3,0":
				case "%5,1":
					formattedAnswerValue = answerValue + '%';
				break;
				case "SINGL":
					formattedAnswerValue = _.get(_.find($s.codeFile,{codeType: codeType,code: answerValue}),'codeValue',answerValue); 
				break;
				case "YN":
                   if(answerValue === "Y"){
					   formattedAnswerValue = "Yes";
				   }else if(answerValue === "N"){
					   formattedAnswerValue = "No";
				   } 
				break;
				case "MULTI":
					var valueList = answerValue;
					valueList = valueList.replace(/["()']/g,""); 
					//then we create an array to compare value to 							
					var values = valueList;
					values = valueList.split(',');
					// if the code type for the question was MONTH we need to order the values by calendar order
					if(_.isEqual(question.CodeType,"MONTH")){
					
					 var months = _.filter($s.codeFile,{codeType:"MONTH"});
	
					 values = _.sortBy(values, x => _.findIndex(months, y => _.isEqual(x,y.code))); 
					}

					// the values we want to dispaly in the grid is the codeValue(s)(button label) of the code(s)(answer choice) chosen. 
					values = _.map(values,function(value){
						
						var displayValue = _.get(_.find($s.codeFile,{code: value}),'codeValue',value);
						if(_.isEqual(displayValue,"None")){
							displayValue = _.get(question,'QuestionDetailsJson.industryGuideline.description');
						}
						return displayValue; 
					});
					values = values.join(', ');


					formattedAnswerValue = values;
	
				break;
				default:
                  formattedAnswerValue = answerValue;

			}
			return formattedAnswerValue;
		};
		$s.formatIndustryGuideline = function(guideline){
  
			 var formattedGuideline = "";
			switch(guideline){
				case "---":
				case undefined:{
					formattedGuideline = "N/A";
				break;
				}
				default:
					formattedGuideline = guideline;
				break;	
			}
			return formattedGuideline;
		};

		$s.test = function(){
			console.log("I was called from the directive!");
		};

		$s.toggleIncludeInudstryRecommends = function(question){
			// since the question's Answer property is tied to the ng-model of the IncludeIndustryRecommneds toggle input ,
			// all we need to do is save the updated state of the question/answer.
			var auditAnswer = _.find($s.auditAnswers,{"QuestionId":question.QuestionId});
			auditAnswer.AnswerDetailsJson = angular.copy(question.Answer); 
			$s.updateAnswers(); 
		};
		
		$s.manageFollowupItems = function(question,isMobile){
		
			
			var mobileIdPrefix = "";
		   if(isMobile === true){
			   mobileIdPrefix = "mobile-";
		   }
			//fist we need to get the FollowupItem property of the question of the row that the followup item toggle was clicked
			// and flip the boolean value
		//	var modelFollowupItem = _.get(question,'Answer.FollowUp');
		    var followupItemToggle = $("#"+mobileIdPrefix+"question-followup-item-"+_.get(question,'QuestionId'));
			var isFollowupItem = followupItemToggle.prop("checked");
            if(isFollowupItem === true){
				
				if(followupItemToggle.length > 0){
					followupItemToggle.prop('checked', true);
				}else{
					log.info("failed to set followup item toggle checked property to true");
				}
				_.set(question,'Answer.FollowUp',true);
			   //when an followup item is added , the FormattedComments initially starts with the value of Notes
			   _.set(question,'Answer.FormattedComments',_.get(question,'Answer.Notes',""));
			  $s.followupItems.push(question);
			
		      $s.followupItems = _.sortBy($s.followupItems,function(followupItem){
				  return _.findIndex($s.orderedQuestionsAndAnswers,{QuestionId: followupItem.QuestionId}); 
			  });
			  var auditAnswer = _.find($s.auditAnswers,{"QuestionId":question.QuestionId});
			  auditAnswer.AnswerDetailsJson = angular.copy(question.Answer); 
			  $s.updateAnswers(); 
			}else{
			   
				MSF.confirm({
					  title: 'Remove',
					  messageHeader: question.SubHeading != "---" ? question.SubHeading+" - "+question.Question : question.Question,
					  message: "Are you sure you want to remove this question? Removing the question will delete anything you've written as a Comment.",
					  confirm: {
						  className: 'danger',
						  icon: 'trash',
						  text: "Remove"
					  }
				}, function confirmFollowupItemRemoval(){
				
					if(followupItemToggle.length > 0){
						followupItemToggle.prop('checked', false);
					}else{
						log.info("failed to set followup item toggle checked property to false");
					}
					// if the user confirms the removal of the followup item we need to set FollowupItem = false because the user might have clicked on the 'X' on the followup item 
					// and we need to reset the Recommend field back to the Notes property of the question.
					_.set(question,'Answer.FollowUp',false);
					_.set(question,'Answer.IncludeIndustryRecommends',false);
					_.set(question,'Answer.FormattedComments',_.get(question,'Answer.Notes',""));
					// we also have to reset other properties that are set on the Review Draft screen, if the followup item is removed, those properties would not have been set in the first place
					_.set(question,'Answer.MgmtAccepted',false);
					_.set(question,'Answer.TargetDate',null);
					_.set(question,'Answer.Status',null);
					$s.followupItems = _.reject($s.followupItems,function(followupItem){ return followupItem.QuestionId === question.QuestionId;});	

					var auditAnswer = _.find($s.auditAnswers,{"QuestionId":question.QuestionId});
					auditAnswer.AnswerDetailsJson = angular.copy(question.Answer); 
					
					$s.updateAnswers(); 				

				},function cancelFollowupItemRemoval(){
					
					if(followupItemToggle.length > 0){
						followupItemToggle.prop('checked', true);
					}else{
						log.info("failed to set followup item toggle checked property to true");
					}
					// if the user cancels the removal , we need to set the FollowupItem proeprty back to true because  it is tied to the model of the toggle.
					 _.set(question,'Answer.FollowUp',true);
					
                     log.info("The followup item removal was canceled");
				});

           
			}
            
         

		};
        // function that start the remove followup item proccess after the X button on the followup item was clicked 
	    $s.toggleRemoveFollowupItemModal = function toggleRemoveFollowupItemModal(question,isMobile){

             console.log('toggleRemoveFollowupItemModal callled');
			 var mobileIdPrefix = "";
            if(isMobile === true){
                mobileIdPrefix = "mobile-";
			}

		   //first we initially set the "checked" property of the toggle to false and the FollowupItem to false as if it was clicked on. 
			var followupItemToggle = $("#"+mobileIdPrefix+"question-followup-item-"+_.get(question,'QuestionId'));
			if(followupItemToggle.length > 0){
				followupItemToggle.prop('checked', false);
			}else{
				log.info("failed to set followup item toggle checked property to false");
			}
			_.set(question,'Answer.FollowUp',false);
			// Then we call manageFollowupItems to start the followup item removal logic
			$s.manageFollowupItems(question,isMobile);
	           
		};

		$s.updateFollowupItem = function updateFollowupItem(question){
              
			var auditAnswer = _.find($s.auditAnswers,{"QuestionId":question.QuestionId});
			auditAnswer.AnswerDetailsJson = angular.copy(question.Answer); 
			
			$s.updateAnswers(); 
		};
       

		$s.updateAnswers = function updateAnswers(){
			if($s.syncInProgress === false && $s.updateInProgress === false){
				$s.syncInProgress = true;	
				$s.checkF360SyncStatus().then(function(){
					$s.updateInProgress = true;
					log.info("updateAnswer: start");
					

					var AnswerJson = JSON.stringify($s.auditAnswers);

					$s.isDirty = true;
					auditService.updateAnswer(auditId, AnswerJson, function getF360Update (err, data) {
							if (err) {
								log.error('error updating answer: ' + err);
								$s.isDirty = false;
								$s.updateInProgress = false;
								$s.syncInProgress = false;
								if($s.finalSaveRequired === true){
									log.info("one more save is required 940");
									$s.finalSaveRequired = false;
									$s.updateAnswers();
								}
								log.info("updateAnswer: error in updating answer on RnW , update end");
							}else{

						
							// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
							if($s.isOnline){
							
													
								$s.isDirty = false;
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
							
									auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
									var auditlistItem = _.find(data,{AuditId: auditId});

									log.info("checkedSync: updating last synced date with : ");
									log.info(auditlistItem);

									//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
									if(!_.isUndefined(auditlistItem)){ 
										auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
											if (err) {
												log.error('error updating server with device data: ' + err);
											}
											
											log.info("udpated audit sync date after answer update");
											$s.updateInProgress = false;
											$s.syncInProgress = false;
											if($s.finalSaveRequired === true){
												log.info("one more save is required 980");
												$s.finalSaveRequired = false;
												$s.updateAnswers();
											}
										});	 
									}else{
										log.info("could not find audit indexedDB , failed to update answer. update end");
										$s.updateInProgress = false;
										$s.syncInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 990");
											$s.finalSaveRequired = false;
											$s.updateAnswers();
										}
										
									
									}

								});
							});
							}else{
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
									$s.updateInProgress = false;
									$s.syncInProgress = false;
									if($s.finalSaveRequired === true){
										log.info("one more save is required 1741");
										$s.finalSaveRequired = false;
										$s.updateAnswers();
									}
									log.info("updateAnswer: offline and updated Is Dirty flag , update end");
								});
							}
						
							console.log('update ok');
						}
					});
				  });
				}else{
					log.info("an answer save attempt was made while another one was going");
					$s.finalSaveRequired = true;
					
				 }
			
		};
		$s.isDirty = true;
		$s.updateResultsAndDraft = function(){
			if($s.syncInProgress === false && $s.updateInProgress === false){
				$s.syncInProgress = true;
				$s.checkF360SyncStatus().then(function(){
					$s.updateInProgress = true;
					log.info("updateResultsAndDraft: start");
					// The next evaluation date should be stored in json field with the pattern "MM/DD/YYYY" , but the NextEvaluationDate field requires a date.
					var reportData = angular.copy($s.report);
					var nextEvaluationDateObject = reportData.resultsWriteRptJson.nextEvaluationDate;
					reportData.resultsWriteRptJson.nextEvaluationDate = formatNextEvaluationDateForServer(reportData.resultsWriteRptJson.nextEvaluationDate);

					var draftNotesJson = JSON.stringify(reportData);
					$s.isDirty = true;
					auditService.updateReviewResults(auditId,draftNotesJson,nextEvaluationDateObject,function(data){
					var error = _.get(data,'Error');
					if(error){
						log.error(error);
						$s.isDirty = false;
						$s.updateInProgress = false;
						$s.syncInProgress = false;
						if($s.finalSaveRequired === true){
							log.info("one more save is required 1052");
							$s.finalSaveRequired = false;
							$s.updateResultsAndDraft();
						}
						log.info("updateResultsAndDraft: update failed, update end");
					}else{

					
						// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
						if($s.isOnline){

										
							$s.isDirty = false;
							auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
								if (err) {
									log.error('error updateing isDirty flag: ' + err);
								}
						
								auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
								var auditlistItem = _.find(data,{AuditId: auditId});

								log.info("updateResultsAndDraft: updating last synced date with : ");
								log.info(auditlistItem);

								//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
								if(!_.isUndefined(auditlistItem)){ 
									auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
										if (err) {
											log.error('error updating server with device data: ' + err);
										}
										
										$s.updateInProgress = false;
										$s.syncInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 1086");
											$s.finalSaveRequired = false;
											$s.updateResultsAndDraft();
										}
										log.info("updateResultsAndDraft: udpated audit sync date after answer update, update end");
									});	 
								}else{
									log.info("updateResultsAndDraft: could not find audit indexedDB, update end");
									$s.updateInProgress = false;
									$s.syncInProgress = false;
									if($s.finalSaveRequired === true){
										log.info("one more save is required 1097");
										$s.finalSaveRequired = false;
										$s.updateResultsAndDraft();
									}
									
								}

							});
						});
						}else{
							auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
								if (err) {
									log.error('error updateing isDirty flag: ' + err);
								}
								$s.updateInProgress = false;
								$s.syncInProgress = false;
								if($s.finalSaveRequired === true){
									log.info("one more save is required 1114");
									$s.finalSaveRequired = false;
									$s.updateResultsAndDraft();
								}
								log.info("updateResultsAndDraft: offline and updated IsDirty flag, update end");
							});
						}
					
					}     

					});
				});
			}else{
			   log.info("an answer save attempt was made while another one was going");
			   $s.finalSaveRequired = true;
			   
			}
		}; 
		$s.validateManagementPlan = function(){
			var validManagementPlan = true;
			var managementPlan = _.get($s.report,'resultsWriteRptJson.formattedHighlights',""); 
			if(_.isUndefined(managementPlan)){
				validManagementPlan = false;
			}else if(_.isEqual(managementPlan.trim(),"")){
                validManagementPlan = false;
			}

			if(validManagementPlan === false){
				$("#managementPlan-container").addClass('error');
				$("#managementPlan-textarea").addClass('error');
				$("#errorInputManagementPlan").removeClass('dis-none');
			}else{
				$("#managementPlan-container").removeClass('error');
				$("#managementPlan-textarea").removeClass('error');
				$("#errorInputManagementPlan").addClass('dis-none');
			}


			return validManagementPlan;
		};
		$s.validateFollowupItems = function(){
			var validNumberOfFollowupItems = true;
			if($s.followupItems.length == 0){
				validNumberOfFollowupItems = false;
			}
			return validNumberOfFollowupItems;
		};
		$s.validateNextEvaluationDate = function(){
		   var validNextEvaluationDate = true;

		   var enteredNextEvaluationDate = angular.copy(_.get($s.report,'resultsWriteRptJson.nextEvaluationDate'));

		 
				if((moment(moment(enteredNextEvaluationDate).format('MM/DD/YYYY')).toDate() < moment(moment($s.minNextEvaluationDate).format('MM/DD/YYYY')).toDate()) || (moment(moment(enteredNextEvaluationDate).format('MM/DD/YYYY')).toDate() > moment(moment($s.maxNextEvaluationDate).format('MM/DD/YYYY')).toDate())){
					validNextEvaluationDate = false;
				}	
			
			if(validNextEvaluationDate === false){
				$("#nextEvaluation-label").addClass('text-red');
				$("#nextEvaluation-container").addClass('error-container');
				$("#errorInputNextEvaluationDate").removeClass('dis-none');
			}else{
				$("#nextEvaluation-label").removeClass('text-red');
				$("#nextEvaluation-container").removeClass('error-container');
				$("#errorInputNextEvaluationDate").addClass('dis-none');	
			}
			

		   return validNextEvaluationDate;
		   
		};
        // function that validates the results and write report and controls the disabled status of the "Review Draft Report" button
		$s.validate = function(){
			var validNumberOfFollowupItems = true;
			var validManagementPlan = true;
			var validNextEvaluationDate = true;
			
			$s.currentTopTabIndex = "";
			$s.currentTopAnchor = "";

           // *note* for the "scroll to top error" functionality to work, the validation for the  controls here needs to procceed in a top down order"
		   // the audit requires the Management Plan is a required field 
			validManagementPlan = $s.validateManagementPlan();

			if(!validManagementPlan){
				$s.currentTopTabIndex = $s.managementPlanTabIndex;
				$s.currentTopAnchor = $s.managementPlanAnchor;
			}
	

			// the audit requires at least one followup item
			
			validNumberOfFollowupItems = $s.validateFollowupItems();

			if(!validNumberOfFollowupItems && _.isEqual($s.currentTopAnchor,"")){
				$s.currentTopTabIndex = $s.followupItemsTabIndex;
				$s.currentTopAnchor = $s.followupItemsAnchor;
			}
			

		
			//the next evaluation date for the audit has to be in the future and with in the next 6 months
		
			validNextEvaluationDate = $s.validateNextEvaluationDate();

			if((!validNextEvaluationDate && _.isEqual($s.currentTopAnchor,"")) || (_.isEqual(_.get($s.report,'resultsWriteRptJson.nextEvaluationDate'),"") && _.isEqual($s.currentTopAnchor,""))){
				// we set validNextEvaluationDate = false here if it fails the second half of this if statement , which is an additional screen level validation
				validNextEvaluationDate = false;
				$("#nextEvaluation-label").addClass('text-red');
				$("#nextEvaluation-container").addClass('error-container');
				$("#errorInputNextEvaluationDate").removeClass('dis-none');
				$s.currentTopTabIndex = $s.nextEvaluationDateTabIndex;
				$s.currentTopAnchor = $s.nextEvaluationDateAnchor;
			}else{
				$("#nextEvaluation-label").removeClass('text-red');
				$("#nextEvaluation-container").removeClass('error-container');
				$("#errorInputNextEvaluationDate").addClass('dis-none');	
			}

            return validNumberOfFollowupItems && validManagementPlan && validNextEvaluationDate; 
		};
        $s.scrollToTopError = function(){
			var topErrorElem = $("#"+$s.currentTopAnchor);
			var container = $("#results-write-report");
			if(!_.isUndefined(topErrorElem)){
				$window.scrollTo(0,topErrorElem.offset().top - container.offset().top + container.scrollTop());
			}
		};
		$s.reportResultsAndWriteComplete = function(){
		   
		    if($s.validate()){
				$s.updateInProgress = true;
				log.info("reportResultsAndWriteComplete: update started");
				$s.currentTopTabIndex = "";
				$s.currentTopAnchor = "";
				// The next evaluation date should be stored in json field with the pattern "MM/DD/YYYY" , but the NextEvaluationDate field requires a date.
			    var reportData = angular.copy($s.report);
				var nextEvaluationDateObject = reportData.resultsWriteRptJson.nextEvaluationDate;
				reportData.resultsWriteRptJson.nextEvaluationDate = formatNextEvaluationDateForServer(reportData.resultsWriteRptJson.nextEvaluationDate);

				var draftNotesJson = JSON.stringify(reportData);
				$s.isDirty = true;
				auditService.updateReviewResults(auditId,draftNotesJson,nextEvaluationDateObject,function(data){
				   var error = _.get(data,'Error');
				   if(error){
				    	log.error(error);
						$s.isDirty = false;
						$s.updateInProgress = false;
				        log.info("reportResultsAndWriteComplete: update failed, update end");
			     	}else{

				
						// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
						if($s.isOnline){

							
							$s.isDirty = false;
							auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
								if (err) {
									log.error('error updateing isDirty flag: ' + err);
								}
						
								auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
								var auditlistItem = _.find(data,{AuditId: auditId});
		
								 log.info("reportResultsAndWriteComplete: updating last synced date with : ");
								log.info(auditlistItem);
		
								 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
								if(!_.isUndefined(auditlistItem)){ 
									auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
										if (err) {
											log.error('error updating server with device data: ' + err);
										}
										
										log.info("reportResultsAndWriteComplete: udpated audit sync date after answer update, update end");
										$s.updateInProgress = false;
										$window.location.href = "#/f360/"+auditId+"/evaluation-overview/result-write-report/review-draft-report";
									});	 
								}else{
									log.info("reportResultsAndWriteComplete: could not find audit indexedDB, update end");
									$s.updateInProgress = false;
							
								}
		
							});
						  });
						}else{
							auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
								if (err) {
									log.error('error updateing isDirty flag: ' + err);
								}
								$s.updateInProgress = false;
								log.info("reportResultsAndWriteComplete: offline and updated Is Dirty flag, update end");
								$window.location.href = "#/f360/"+auditId+"/evaluation-overview/result-write-report/review-draft-report";
							});
						}

					
				
				
				   }     

				});
				
				
			}else{
               if(!_.isEqual($s.currentTopTabIndex,"") && !_.isEqual($s.currentTopAnchor,"")){
				  $s.scrollToTopError();
			   }
			}

			
		};
		$s.addQuestionCategories = function(){
			//test interval 22
			var firstIntervalStartIndex = 2;
			var secondIntervalStartIndex = 25;
			var thirdIntervalStartIndex = 48;
			var fourthIntervalStartIndex = 71;
			var fifthIntervalStartIndex = 94;
			var sixthIntervalStartIndex = 117;

			_.forEach($s.auditQuestions,function(question){
                switch(true){
					case  (question.QuestionId >= 2 && question.QuestionId < 25):
					  _.set(question,'category','Cow Comfort');
					break;
					case (question.QuestionId >= 25 && question.QuestionId < 48):
						_.set(question,'category','Data Quality');
						break;
					case (question.QuestionId >= 48 && question.QuestionId < 71):
						_.set(question,'category','Fertility');
						break;
					case (question.QuestionId >= 71 && question.QuestionId < 94):
						_.set(question,'category','Nutrition');
						break;		
					case (question.QuestionId >= 94 && question.QuestionId < 117):
						_.set(question,'category','Personnel');
						break;
					case (question.QuestionId >= 117 && question.QuestionId < 140):
						_.set(question,'category','Transition Cow');
						break;
					case (question.QuestionId >= 141):
						_.set(question,'category','Unassigned');
						break;		

				}
			});
			
		};

	    function loadReportData(){
			auditService.getIndexedDBReviewResultsAndDraft(self.auditId, function getIndexedDBReviewResultsAndDraft(err, data) {
				if (err) {
					log.error('error getting F360 Review Results And Draft Data: ' + err);
					MSF.confirmation.danger(err,false);
				}

				if (data && data.length) {
					var reportData = JSON.parse(data);

					var nextEvalDate = _.get(reportData,'resultsWriteRptJson.nextEvaluationDate');
					if(_.isUndefined(nextEvalDate) || _.isEqual(nextEvalDate,"")){
						nextEvalDate = moment().add('days', 180).toDate();
					}else{
						
						//nextEvalDate = moment(nextEvalDate).add(moment(nextEvalDate).utcOffset(), 'minutes').toDate();								
						nextEvalDate = moment(nextEvalDate).toDate();								
					}
					
					// in the database next evaluation date is stored as a string, the date input control requires a date
				
					_.set(reportData,'resultsWriteRptJson.nextEvaluationDate',nextEvalDate);

							

					buildReportData(reportData);

					if (!window.navigator.onLine) {
						//$s.$apply();
					}
				}else{
					buildDefaultData();
				}
			
					auditService.getIndexedDBOverViewList(self.auditId, function getIndexedDBOverViewList(err, data) {
						if (err) {
							log.error('error getting F360 Over View List: ' + err);
							MSF.confirmation.danger(err,false);
						}
						if (data && data.length) {
							$s.overViewList = data;
							for (let index = 0; index < $s.overViewList.length; index++) {
								$s.overViewList[index].AnswerCnt = 0;
								$s.overViewList[index].QuestionCnt = 0;
							}
							if (!window.navigator.onLine) {
							//	$s.$apply();
							}
						}

							auditService.getIndexedDBQuestionList(auditId, function getIndexedDBQuestionList(err, data) {
							if (err) {
								log.error('error getting F360 Over View List: ' + err);
								MSF.confirmation.danger(err,false);
							}
							
							if (data && data.length) {
								var arrQuestion = [];
								var parseDataQuestion = JSON.parse(data);
								var questionDetailsJson = parseDataQuestion.QuestionsJson;
							
								for (let i = 0; i < questionDetailsJson.length; i++) {
									arrQuestion.push(questionDetailsJson[i].QuestionJson[0]);
								}
								// we need to order the questions here in the ux because the questions come from a JSON field
								// intead their own records in a table.
								$s.auditQuestions = _.sortByOrder(arrQuestion,['SortOrder'],['asc']);

								

								auditService.getIndexedDBAnswerList(auditId, function getIndexedDBAnswerList(err, data) {
									if (err) {
										console.log('error getting F360 Over View List: ' + err);
										MSF.confirmation.danger(err,false);
									} 
									if (data && data.length) {
										try{
										 $s.auditAnswers = JSON.parse(data);
										}catch(e){
										  log.error("failed to parse answer list json : "+_.get(e,'message'," "));
										}
									 
									 
									 } else {
										$s.auditAnswers = [];
									 }

									//if the not applicable question is checked we have to exclude certain questions including the NA question itself. 
									removeExcludedQuestions();

									$s.$applyAsync(function(){
										buildSectionsQuestionsAndAnswers();							
										loadFollowupItems();
										loadReportCharts();
								    });
									

								});

							} else {
								$window.location.href = '#/f360';
							}
						});
					});
				});
			}
		

			$s.syncingBackOnline = false;
		   
			deregOnlineCheckWatch =	$s.$on('online:change',function(event,onLineChange){
			 
					var onLineValue = _.get(onLineChange,'value');
					var isOnlineOldValue =  angular.copy($s.isOnline);
					$s.isOnline = onLineValue; 
					// if the device was previously offline and now back online
				 // we need to see if we will run checkF360SyncStatus
				 if(isOnlineOldValue === false && onLineValue === true){
					  if($s.syncingBackOnline === false){
						  $s.syncingBackOnline = true;
						  $s.syncInProgress = true;
						  $s.checkF360SyncStatus().then(function(){
							 $s.syncingBackOnline = false;
							 $s.syncInProgress = false;
						
						  });
					  } 
				 }
				 
			 });

			 $s.checkF360SyncStatus = function checkF360SyncStatus() {
				var syncStatusPromise = $q.defer();

				if ($s.isOnline && $s.updateInProgress === false) {


				
					log.info("Results and Write: checkSync: Synch in Progress");

					auditService.getIndexDBListByHerdId(function getF360List(err, data){
						
						if(err){
							log.error("There was err in getting cached list : "+err);
							syncStatusPromise.reject(true);
							MSF.loadPage('Fertility360report');
						}

						var activeAuditListData = _.find(data,{AuditId: self.auditId});
						var lastSyncedDate = _.get(activeAuditListData,'SyncedOn',null);
						if(_.isEqual(lastSyncedDate,"")){
							lastSyncedDate = null;
						}
							
					   var  isDeviceDirty = _.get(activeAuditListData,'IsDeviceDirty',false);
					   
					     //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
						 if(	$s.updateInProgress === true){
							log.info("Section Page : a save has started before calling getSyncedSatus canceling this interval of check sync");
							syncStatusPromise.reject(true);
							   return;
						   }

					   log.info("check Sync: calling getSyncStatus with lastSyncedDate: "+lastSyncedDate+" and isDeviceDirty: "+isDeviceDirty);
					   api.getSyncStatus(self.auditId,lastSyncedDate,isDeviceDirty, function getF360SyncStatus(err, data) {
								if (err) {
									self.isSync = false;
									log.error('error getting F360 online check: ' + err);
								}
								  //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
								  if(	$s.updateInProgress === true){
									log.info("Section Page : a save has started after calling getSyncedSatus canceling this interval of check sync");
									syncStatusPromise.reject(true);
									   return;
								   }
								
								if (data) {
									self.isSync = true;
								
									var syncData = data[0];	

									if(!_.isUndefined(syncData)){
									
										log.info("checkedSync: synce data returned with");
										log.info(syncData);
										if((_.isEqual(_.get(syncData,'ToUpdateServer'),true)) || (_.isEqual(_.get(syncData,'ToUpdateServer').toLowerCase(),"true"))){

											log.info("checkedSync: server needed updating");
											auditService.updateServerAuditData(self.auditId,function(err,data){
												if (err) {
													log.error('error updating server with device data: ' + err);
													$s.isDirty = true;
												}else{
													$s.isDirty = false;
												}
												log.info("update server complete");
												// we need to update the IsDeviceDirty flag of the audit in IndexDB
												auditService.updateIsDirty(self.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
													if (err) {
														log.error('error updateing isDirty flag: ' + err);
													}
													log.info("checkedSync: update IsDeviceDirty complete");
													// we need to call up the database version of SyncedOn because the update server proccess sets a more current SyncedOn on the server side
													auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
														var auditlistItem = _.find(data,{AuditId: self.auditId});
	
														log.info("checkedSync: updating last synced date with : ");
														log.info(auditlistItem);
	
														 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
														if(!_.isUndefined(auditlistItem)){ 
															auditService.updateLastSyncedDate(self.auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
																if (err) {
																	log.error('error updating server with device data: ' + err);
																}
																
																log.info("checkedSync: last synced date update complete , sync end");
															
																syncStatusPromise.resolve(true);
			
															});	 
														}else{
															log.info("checkedSync: audit was deleted . so no need to update last synced date. sync end ");
														
															syncStatusPromise.resolve(true);
														}
		
													});
												});
												
												
	
											});
										}else{
										   // the device's SyncedOn Date is older than the server's copy of the same property and the device needs updating
											log.info("checkSync: server is up to date , need to check if device needs updating");
												if((_.isEqual(_.get(syncData,'ToUpdateDevice'),true)) || (_.isEqual(_.get(syncData,'ToUpdateDevice').toLowerCase(),"true"))){
													log.info("checkSync: device needs updating , setting device update flag true , sync end");
												
													 // if the device needs updating then we need to send the user back to the f360 dashboard to attempt a device sync after prompt
												
													syncStatusPromise.reject(true);
													MSF.loadPage('Fertility360report');
												}else{
													log.info("checkSync: no server update needed , sync end");
											
													syncStatusPromise.resolve(true);
												}
											  
										}
									} else {
										log.info("checkedSync: no getSyncedStatus data returned , sync end");
									
										syncStatusPromise.resolve(true);
									}

								} else {
								
									syncStatusPromise.resolve(true);
								}	
							});
						});
				} else {
			
					syncStatusPromise.resolve(true);
				}
			  return syncStatusPromise.promise;
			};
	
			$s.$on("$destroy", function() {

				deregOnFarmChange();
				deregOnlineCheckWatch();
			});
			
			deregOnFarmChange =	$s.$on('farm:changed',function(){
									MSF.loadPage('Fertility360report');
								});
			MSF.ready(function onMsfReady() {
				$s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
				$s.codeFileQuestionCategories = _.filter($s.codeFile,{codeType: "F360CATEGORY"});
				//local storage data 	
				var mySynchStateJSON = localStorage.getItem('MySynch-state');
				if(!_.isUndefined(mySynchStateJSON)){
					$s.mySynchState = JSON.parse(mySynchStateJSON);

					$s.activeFarm = _.get($s.mySynchState,'value.activeFarm',{});
				}

				auditService.getActiveOrCurrentAuditVersion().then(function(apiVersion){
					$s.auditApiVersion = apiVersion;
			    });
				// first we want to check if the user has permissions to view this page/audit
				$s.checkPermissions(function(){
					// then we have to check if the server or the device needs updating 
					$s.syncInProgress = true;
					$s.initCheckSyncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						$s.syncInProgress = false;
						$s.initCheckSyncInProgress = false;
						// then as long as the user wasn't kicked back to the dashboard, continue to load this screen's data
						loadCurrentHerd(function(){
							loadReportData();
						});				
						
					});

				}); 
				
			
			
			});
		}
	]);
})();
